enum MimeType {
  PDF = 'application/pdf',
}

export { MimeType }
